import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=2ce09293&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=2ce09293&prod&lang=scss"
import style1 from "./Main.vue?vue&type=style&index=1&id=2ce09293&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce09293",
  null
  
)

export default component.exports